import React from 'react';
import styles from './BoostPageHeader.module.scss';

const BoostPageHeader = () => (
  <div className={styles.container}>
    <div className={styles.border} />
    <h1 className={styles.title}>Boost My Box & Bonus Favorites</h1>
    <h4 className={styles.description}>Add Coveted Choices to Your Box</h4>
    <p className={styles.text}>
      In addition to Boost My Box, we&apos;ve added Bonus Favorites! You can
      snag products you might have missed in a past box at up to 60% off. This
      is only available while supplies last, so don&apos;t miss out (again!).
    </p>
  </div>
);

export default BoostPageHeader;
